<template>
  <v-data-table
    class="v-data-table--listing elevation-1 pa-6 mt-16"
    :footer-props="footerOptions"
    :headers="headers"
    :items="collections"
    :options.sync="options"
    :search="searchString"
    height="500"
    item-key="id"
    fixed-header>
    <template #top>
      Total Collections: {{ collections.length }}
      <v-text-field
        v-model="searchString"
        class="mb-4"
        placeholder="Search for collections"
        prepend-inner-icon="mdi-magnify" />
    </template>
    <template #[`item.name`]="{ item: collectionItem }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="collections-name"
            v-bind="attrs"
            v-on="on">
            {{ collectionItem.name }}
          </div>
        </template>
        <span>{{ collectionItem.name }}</span>
      </v-tooltip>
    </template>
    <template
      #[`item.action`]="{ item: collectionItem }">
      <v-row
        no-gutters
        class="control-actions">
        <input
          v-model="inputRatingValue"
          min="1"
          autofocus
          type="number"
          @keypress="isInteger">
        <div class="d-flex flex-column ml-3">
          <v-tooltip
            v-for="item in controlIcons"
            :key="item.action"
            bottom>
            <template #activator="{ on }">
              <v-icon
                color="mainGrey"
                @click="changeCollectionPosition({
                  action: item.action,
                  item: collectionItem,
                  value:inputRatingValue
                })"
                v-on="on">
                {{ item.icon }}
              </v-icon>
            </template>
            <span>
              {{ item.title }}
            </span>
          </v-tooltip>
        </div>
      </v-row>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: 'CollectionsTable',
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    controlIcons: [
      {
        title: 'Boost', icon: 'mdi-arrow-up-bold-circle-outline', action: 'boost',
      },
      {
        title: 'Reduce', icon: 'mdi-arrow-down-bold-circle-outline', action: 'reduce',
      },
    ],
    footerOptions: {
      itemsPerPageOptions: [50, 100, 200],
      showCurrentPage: true,
      showFirstLastPage: true,
    },
    headers: [
      {
        text: 'Collection name', value: 'name', sortable: false, align: 'left',
      },
      {
        text: 'Rating', value: 'rating', sortable: false, align: 'left', width: 200,
      },
      {
        text: 'Action', value: 'action', sortable: false, align: 'left', width: 200,
      },
    ],
    inputRatingValue: 0,
    options: {
      itemsPerPage: 50,
      mustSort: true,
      page: 1,
      sortBy: ['name'],
      sortDesc: [false],
    },
    searchString: '',
  }),
  watch: {
    searchString() {
      this.options.page = 1;
    },
  },
  methods: {
    ...mapActions({
      manageCollectionRatingBoost: 'Collections/manageCollectionRatingBoost',
    }),
    async changeCollectionPosition(data) {
      await this.manageCollectionRatingBoost({
        ...data,
      });
    },
    isInteger(evt) {
      const theEvent = evt || window.event;
      let key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
      if (key.length === 0) return;
      const regex = /^[0-9\b]+$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.v-data-table {
  .control-actions {
    display: none;
  }
  tr:hover {
    .control-actions {
      display: flex;
      input {
        &:focus-visible {
          outline: none;
        }
        border-style: solid;
        border-color: var(--v-lightGrey-base);
        width: 90px;
        border-radius: 5px;
        font-size: 14px;
      }
    }
  }
}
.collections-name {
  max-width: 528px!important;
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  white-space: pre!important;
}
</style>
